// extracted by mini-css-extract-plugin
export default {"master-data__container":"styles_master-data__container__6VlYX","title":"styles_title__F-Fn4"};